import { useState, useCallback } from "react";
import { apiFetch } from "@/lib/api";

export type DialogueAction =
  | "approfondir"
  | "expliquer"
  | "verifier"
  | "non_pertinent";

export interface DialogueEntry {
  action: DialogueAction;
  passage: string;
  response: unknown;
  ts: number;
}

export function useDialogueQorum(conversationId: string) {
  const [history, setHistory] = useState<DialogueEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const sendAction = useCallback(
    async (action: DialogueAction, passage: string) => {
      if (!conversationId) return;
      setLoading(true);
      setError(null);
      try {
        const res = await apiFetch<unknown>(
          `/api/chat/${conversationId}/stabilo`,
          {
            method: "POST",
            body: JSON.stringify({
              action,
              passage,
              anchor_message_id: null,
            }),
          },
        );
        setHistory((prev) => [
          ...prev,
          { action, passage, response: res, ts: Date.now() },
        ]);
      } catch (e) {
        const msg =
          e instanceof Error ? e.message : "Erreur lors de l'appel au Conseil";
        setError(msg);
      } finally {
        setLoading(false);
      }
    },
    [conversationId],
  );

  const reset = useCallback(() => {
    setHistory([]);
    setError(null);
  }, []);

  return { history, loading, error, sendAction, reset };
}
